const orderModal = document.getElementById("product-contact-order-modal");

if (orderModal) {
    const form = orderModal.querySelector("form.contact-form");
    const button = orderModal.querySelector(".tt-order-submit");
    const feedback = orderModal.querySelector(".tt-order-feedback");
    const image = orderModal.querySelector('[data-bb-value="product-contact-order-image"]');
    const defaultImage = image?.src;

    orderModal.addEventListener("show.bs.modal", (event) => {
        if (feedback) {
            feedback.textContent = "";
            feedback.classList.remove("is-error");
        }
        orderModal.querySelectorAll(".contact-message").forEach((message) => {
            message.textContent = "";
            message.style.display = "none";
        });

        if (image) {
            const trigger = event.relatedTarget;
            image.src = trigger?.dataset.productImage || defaultImage;
            image.alt = trigger?.dataset.productName || "Sản phẩm Thuận Thiên";
        }
    });

    orderModal.addEventListener("hidden.bs.modal", () => form?.reset());

    if (form && button && window.jQuery) {
        const isOrderRequest = (settings) =>
            settings.type?.toUpperCase() === "POST" &&
            settings.data instanceof FormData &&
            new URL(settings.url, window.location.href).href === form.action &&
            settings.data.get("display_fields") ===
                form.querySelector('input[name="display_fields"]')?.value;

        jQuery(document).on("ajaxSend", (_event, _xhr, settings) => {
            if (!isOrderRequest(settings)) return;
            if (feedback) feedback.textContent = "";
            button.classList.add("is-submitting");
            button.textContent = "Đang gửi yêu cầu...";
            button.disabled = true;
            button.setAttribute("aria-busy", "true");
        });

        jQuery(document).on("ajaxSuccess", (_event, xhr, settings) => {
            if (!isOrderRequest(settings)) return;
            const response = xhr.responseJSON;
            if (feedback && response?.message) {
                feedback.textContent = response.message;
                feedback.classList.toggle("is-error", Boolean(response.error));
            }
        });

        jQuery(document).on("ajaxError", (_event, xhr, settings) => {
            if (!isOrderRequest(settings) || !feedback) return;
            const errors = xhr.responseJSON?.errors;
            feedback.textContent = errors
                ? Object.values(errors).flat().join(" ")
                : xhr.responseJSON?.message || "Không thể gửi yêu cầu. Vui lòng thử lại.";
            feedback.classList.add("is-error");
        });

        jQuery(document).on("ajaxComplete", (_event, _xhr, settings) => {
            if (!isOrderRequest(settings)) return;
            button.classList.remove("is-submitting");
            button.innerHTML = 'Gửi yêu cầu tư vấn <span aria-hidden="true">→</span>';
            button.disabled = false;
            button.removeAttribute("aria-busy");
        });
    }
}
